import type { Select } from './select';

export function DisplayLabel(this: Select): string {
  const _selectedOptions = this.options().filter((option) =>
    this.multiSelect() ? this.value().includes(option.value) : option.value === this.value(),
  );

  if (_selectedOptions.length === 0) {
    return this.label() || this.allItemsLabel() || '';
  } else if (_selectedOptions.length === 1) {
    return _selectedOptions[0].label;
  }

  return `${_selectedOptions[0].label} + ${_selectedOptions.length - 1} more`;
}
